import { h, Component, Element, Prop, State, Host } from '@stencil/core';

@Component({
  shadow: false,
  scoped: true,
  styleUrl: `igws-author-profile.less`,
  tag: 'igws-author-profile',
})
export class AuthorProfileComponent {
  @Element() el!: HTMLIgwsAuthorProfileElement;

  /** Select the type to display  */
  @Prop() type: 'page' | 'widget' = 'page';

  /** Author name  */
  @Prop() name: string = '';

  /** Author avatar  */
  @Prop() imgSrc: string = '';

  /** Avatar alternate text */
  @Prop() imgAlt: string = '';

  /** Author job position */
  @Prop() position: string = '';

  /** Author location */
  @Prop() location: string = '';

  /** Author facebook url */
  @Prop() facebook: string = '';

  /** Author linkedin url */
  @Prop() linkedin: string = '';

  /** Author twitter url */
  @Prop() twitter: string = '';

  /** Author instagram url */
  @Prop() instagram: string = '';

  /** Author google plus url */
  @Prop() googlePlus: string = '';

  /** Toogle facebook visibility */
  @Prop() showFacebook: boolean = false;

  /** Toogle linkedin visibility */
  @Prop() showLinkedin: boolean = false;

  /** Toogle twitter visibility */
  @Prop() showTwitter: boolean = false;

  /** Toogle instagram visibility */
  @Prop() showInstagram: boolean = false;

  /** Toogle google plus visibility */
  @Prop() showGooglePlus: boolean = false;

  /** Toogle author experience visibility */
  @Prop() showExperience: boolean = false;

  /** Toogle author summary visibility */
  @Prop() showSummary: boolean = false;

  /** Toogle author education visibility */
  @Prop() showEducation: boolean = false;

  /** Redirect to author profile page */
  @Prop() profileUrl: string = '';

  /** Specify i18n for read more button */
  @Prop() readMoreTranslation: string = 'Read More';

  /** Specify i18n for "follow me" title */
  @Prop() followMeTranslation: string = 'Follow me online';

  /** Specify i18n for "summary" title */
  @Prop() summaryTranslation: string = 'Summary';

  /** Specify i18n for "education" title */
  @Prop() educationTranslation: string = 'Education';

  /** Specify i18n for "experience" title */
  @Prop() experienceTranslation: string = 'Experience';

  @State() slots = [
    {
      shouldRender: this.showSummary,
      name: 'summary',
      label: this.summaryTranslation,
    },
    {
      shouldRender: this.showExperience,
      name: 'experience',
      label: this.experienceTranslation,
    },
    {
      shouldRender: this.showEducation,
      name: 'education',
      label: this.educationTranslation,
    },
  ];

  private get shouldHideIconsWrapper() {
    return [this.showFacebook, this.showInstagram, this.showLinkedin, this.showTwitter, this.showGooglePlus].every(
      item => !item
    );
  }

  private renderAuthorSocials() {
    return (
      <div class={`${this.type}__author-socials${this.shouldHideIconsWrapper ? ' hide' : ''}`}>
        <p class={`${this.type}__author-follow-title`}>{this.followMeTranslation}:</p>
        <div class={`${this.type}__author-social-icons-wrapper`}>
          {this.showFacebook ? <a href={this.facebook} class={`${this.type}__author-facebook socials`}></a> : null}
          {this.showLinkedin ? <a href={this.linkedin} class={`${this.type}__author-linkedin socials`}></a> : null}
          {this.showInstagram ? <a href={this.instagram} class={`${this.type}__author-instagram socials`}></a> : null}
          {this.showTwitter ? <a href={this.twitter} class={`${this.type}__author-twitter socials`}></a> : null}
          {this.showGooglePlus ? (
            <a href={this.googlePlus} class={`${this.type}__author-google-plus socials`}></a>
          ) : null}
        </div>
      </div>
    );
  }
  private renderAuthorSlots() {
    return (
      <div
        class={`${this.type}__author-summaries-wrapper${this.slots.every(slot => !slot.shouldRender) ? ' hide' : ''}`}
      >
        {this.slots.map(slot =>
          slot.shouldRender ? (
            <div class={`${this.type}__author-slot-wrapper`}>
              <h3>{slot.label}</h3>
              <slot name={slot.name}></slot>
              {this.type === 'widget' ? (
                <a href={this.profileUrl} class={`${this.type}__author-read-more`} target="_blank">
                  {this.readMoreTranslation}
                </a>
              ) : null}
            </div>
          ) : null
        )}
      </div>
    );
  }

  private renderWidgetType() {
    return (
      <div class="widget">
        <div class="widget__author-basic-info">
          <div class="widget__author-img-wrapper">
            <img class="widget__author-img" src={this.imgSrc} alt={this.imgAlt} />
          </div>
          <div class="widget__author-titles">
            <h2 class="widget__author-name">{this.name}</h2>
            <p class="widget__author-position">{this.position}</p>
            <p class="widget__author-location">{this.location}</p>
          </div>
          {this.renderAuthorSocials()}
        </div>
        {this.renderAuthorSlots()}
      </div>
    );
  }

  private renderPageType() {
    return (
      <div class="page">
        <img class="page__author-img" src={this.imgSrc} alt={this.imgAlt} />
        <div class="page__author-basic-info">
          <h2 class="page__author-name">{this.name}</h2>
          <p class="page__author-position">{this.position}</p>
          <p class="page__author-location">{this.location}</p>
        </div>
        {this.renderAuthorSocials()}
        {this.renderAuthorSlots()}
      </div>
    );
  }

  render() {
    return (
      <Host>
        <div class="container">{this.type === 'widget' ? this.renderWidgetType() : this.renderPageType()}</div>
      </Host>
    );
  }
}
